import { KYMW2400Model } from '../kymw2400.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';

/**
 * セクション選択コマンド。
 * 管理クラスに選択されたセクションのIDを渡し、セクションの情報を取り出してもらう。
 *
 * @export DeleteSectionService
 * @class DeleteSectionService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class DeleteSectionService {

  private model: KYMW2400Model = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
  }

  /**
   * セクション情報取得
   *
   * @param {KYMW2400Model} model モデルクラス
   * @memberof DeleteSectionService
   */
  execute(model: KYMW2400Model) {
    this.model = model;
    this.model.clearSelectedSectionInfo();
  }
}
